import { render, staticRenderFns } from "./InvestmentDetail.vue?vue&type=template&id=1a7ab329&scoped=true"
import script from "./InvestmentDetail.vue?vue&type=script&lang=js"
export * from "./InvestmentDetail.vue?vue&type=script&lang=js"
import style0 from "./InvestmentDetail.vue?vue&type=style&index=0&id=1a7ab329&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ab329",
  null
  
)

export default component.exports